import React from 'react';
import clsx from 'clsx';

interface Stat {
  label: string;
  value: string;
  unit?: string;
  meta?: string;
}

interface StatPairProps {
  left: Stat;
  right: Stat;
}

/**
 * Two big mono numerals side-by-side with a thin vertical rule between them.
 * Used in the detail screen header for "Height limit / Your car".
 */
export const StatPair: React.FC<StatPairProps> = ({ left, right }) => (
  <div className="flex items-stretch border border-rule rounded-lg bg-card overflow-hidden">
    <StatCell stat={left} className="flex-1 border-r border-rule" />
    <StatCell stat={right} className="flex-1" />
  </div>
);

const StatCell: React.FC<{ stat: Stat; className?: string }> = ({ stat, className }) => (
  <div className={clsx('p-s4 flex flex-col gap-1', className)}>
    <span className="caption text-ink3">{stat.label}</span>
    <span className="flex items-baseline gap-1.5">
      <span className="font-mono text-[28px] leading-none text-ink1">{stat.value}</span>
      {stat.unit ? (
        <span className="font-sans text-[11px] font-medium text-ink3 uppercase tracking-widest">
          {stat.unit}
        </span>
      ) : null}
    </span>
    {stat.meta ? (
      <span className="text-[11px] text-ink3 font-sans">{stat.meta}</span>
    ) : null}
  </div>
);
